<div *ngIf="field.dirty && status == 'INVALID' && field.touched && errorsKeys.length > 0" class="alert alert-danger">
  <ul>
    <li *ngFor="let key of errorsKeys">
      {{ 'error.' + key | translate:{ reason: buildReason(field) } }}
    </li>
  </ul>
</div>
